/**
 * 东伟-数据
 */
// 西安东伟幕墙门窗科技有限公司
const dw_banner1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dw_banner1.png";
const dw_banner2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dw_banner2.png";
const dw_banner3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dw_banner3.png";
//荣誉证书
const dwC6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwC6.png";
const dwC7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwC7.jpg";
const dwC8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwC8.jpg";
const dwC9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwC9.jpg";
const dwC10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwC10.jpg";
const dwC11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwC11.jpg";
const dwC12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwC12.png";

//资质证书
const dwQ = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ.png";
const dwQ1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ1.png";
const dwQ2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ2.jpg";
const dwQ3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ3.png";
const dwQ4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ4.png";
const dwQ5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ5.jpg";
const dwQ6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ6.jpg";
// const dwQ7 = 'https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ7.jpg'
const dwQ8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ8.jpg";
const dwQ9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ9.jpg";
const dwQ10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ10.jpg";
const dwQ11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ11.png";
const dwQ12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwQ12.png";

const dwVr = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/vRlogo.jpg";
const dwVd = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/vRlogo.jpg";

// const dwlogo = "@/assets/image/hplogo.png"

//轮播图
const dwf1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwf1.png";
const dwf2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwf2.png";
const dwf3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwf3.png";
const dwf4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwf4.png";
const dwf5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwf5.png";
const dwf6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwf6.png";

//合作证明
const dwhz1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz1.png";
const dwhz2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz2.png";
const dwhz3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz3.png";
const dwhz4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz4.png";
const dwhz5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz5.png";
const dwhz6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz6.png";
const dwhz7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz7.png";
const dwhz8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz8.png";
const dwhz9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz9.png";
const dwhz10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwhz10.png";

//产品列表
const dwcp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp1.png";
const dwcp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp2.png";
const dwcp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp3.png";
const dwcp4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp4.png";
const dwcp5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp5.png";
const dwcp6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp6.png";
const dwcp7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp7.png";
const dwcp8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp8.png";
const dwcp9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp9.png";
const dwcp10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp10.png";
const dwcp11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp11.png";
const dwcp12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp12.png";
const dwcp13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp13.png";
const dwcp14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp14.png";
const dwcp15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp15.png";
const dwcp16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp16.png";
const dwcp17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp17.png";
const dwcp18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp18.png";
const dwcp19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp19.png";
const dwcp20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp20.png";
const dwcp21 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp21.png";
const dwcp22 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwcp22.png";

const dwbg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwbg1.png";
const dwbg2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwbg2.png";
const dwbg3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwbg3.png";
const dwbg4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dongwei/dwbg4.png";
const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
export default {
	homeData: {
		herderBanner: [dw_banner1, dw_banner2, dw_banner3],
		//企业名称
		headerTitle: "西安东伟幕墙门窗科技有限公司",
		moreInfoName: "东伟幕",
		//企业logo
		logo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/logo/dwlogo.png",
		//企业介绍
		overview:
			" 西安东伟幕墙门窗科技有限公司成立于2014年4月15日，注册资金5180万元。公司经营范围为幕墙工程、室内外装饰装修工程、防水防腐保温工程、钢结构工程、门窗工程的设计、施工；门窗、玻璃、五金、家居装饰建材的研发、生产、销售等。公司现有人员150余人，其中大专以上学历占40%左右。公司组织架构清晰、岗位职责明确，生产、加工能力居同行业水平前列。公司成立以来，一直秉承“以品质求发展、以服务树口碑”的经营理念，并要求全员牢记“诚实、认真、谦让、进取”的企业方针，脚踏实地、团结协作、努力拼搏。为了将门窗事业做的更好，2019-2021年，我司高薪聘请了专业人员组成了研发团队研发了有独立专利的“素派门窗”，产品试制成功后并取得了“素派”的各类商标注册证书，自此，“素派门窗”成为我公司的自有品牌；我司还成功申请并获得了新型铝合金门窗加工装置等实用新型专利证书及发明专利证书。目前，智能制造已成为我国建设制造强国的主攻方向，加快发展智能制造是推动中国制造迈向高质量发展、形成国际化竞争优势的必由之路。为了响应政府倡导的绿色环保、智能制造的要求，2022年初，公司耗资500多万元购置了全自动智能一体化的门窗制造、机器人生产线及比利时的驱动软件，以满足消费者智能生产及个性化定制的需求，同时也使得我公司的门窗加工生产中心的智能化管理更加的高效和科学。通过坚持不懈的努力，公司先后取得了安全生产许可证，建筑装修装饰工程专业承包一级、建筑幕墙工程专业承包一级资质及工程设计专项资质建筑幕墙工程设计乙级、建筑装饰工程设计乙级资质，耐火窗的其他材质非隔热防火窗的消防产品认证书，还被中国商务诚信公共服务平台评选为2020年-2023年度的“企业信用评价AAA级信用企业”。公司先后承建了西安市植物园、都市春天、警官学校、星火地产旭景新港、西安第四军医大职工住宅、大兴医院、华商传媒中心、利君未来城、西北中联设计研究院、欧亚国际、山水草堂、星河湾、旺座曲江、陕西省地震局职工住宅楼、桃园一坊、地铁九号线、陕师大长安新校区等项目，普遍获得客户的好评。",
		//企业Vr背景
		vRlogo: dwVr,
		isShowVrModal: false,
		isShowVr: true,
		vRurl: "",
		isVideo: true,
		videoLogo: "",
		videoUrl: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/mp4/dw.mov",
		//首页banner
		bannerHeight: "200px",
		banner: ["http://www.chuanbaiyu.com/templets/default/images/banner.jpg"],
		//公司官网
		website: "http://www.supaimc.com",
		//经营品类
		categories:
			"幕墙工程、室内外装饰装修工程、防水防腐保温工程、钢结构工程、劳务工程、门窗工程的设计、施工；门窗、玻璃、五金、家居装饰建材的研发、生产、销售；自营场所房屋租赁（依法须经批准的项目，经相关部门批准后方可开展经营活动）。",
		//公司地址
		companyAddress: "陕西省西安市蓝田县西北家具工业园新港七路副二号",
		site: "陕西省西安市",
		//经营模式
		mode: "生产型企业",
		// 经营状态
		operatingStatus: "开业",
		//注册资金
		capital: "5180万人民币",
		//成立日期
		establishment: "2014-04-15",
		//经营品牌
		brand: "素派门窗",
		//主营产品
		mainProducts: "幕墙工程、室内外装饰装修工程、防水防腐保温工程、钢结构工程、劳务工程、门窗工程；门窗、玻璃、五金;",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: "1.现款现结 2.预付款（可与其他项组合）3.货到付款4.按工程进度付款5.完工结算",
		//工厂地址
		factoryAddress: "陕西省西安市蓝田县西北家具工业园新港七路副二号",
		//工厂人数
		factoryHeadcount: "100人",
		//产能
		capacity: "10万平方米",
		//年产值
		annualOutputValue: "--",
		//联系负责人
		person: "客服",
		//联系电话
		contactNumber: "400-700-9860",
		//资质证书
		qualificationList: [
			{
				name: "安全生产许可证",
				path: dwQ,
			},
			{
				name: "高新技术企业",
				path: dwQ1,
			},
			{
				name: "工程设计资质",
				path: dwQ2,
			},
			{
				name: "环境管理体系认证",
				path: dwQ3,
			},
			{
				name: "建筑业企业一级",
				path: dwQ4,
			},
			{
				name: "两化融合",
				path: dwQ5,
			},
			{
				name: "绿建三星",
				path: dwQ6,
			},
			{
				name: "绿色工厂",
				path: dwQ8,
			},
			{
				name: "企业信用评价AAA级信用企业",
				path: dwQ9,
			},
			{
				name: "营业执照",
				path: dwQ10,
			},
			{
				name: "职业健康安全管理认证",
				path: dwQ11,
			},
			{
				name: "质量管理认证",
				path: dwQ12,
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "315重点推荐品牌",
				path: dwC6,
			},
			{
				name: "产品碳足迹",
				path: dwC7,
			},
			{
				name: "节能环保",
				path: dwC8,
			},
			{
				name: "年度央视广告播出企业",
				path: dwC9,
			},
			{
				name: "设计专业委员会理事单位",
				path: dwC10,
			},
			{
				name: "系统门窗展会AAAAA企业",
				path: dwC11,
			},
			{
				name: "中国科技创新重点推广",
				path: dwC12,
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "陕西西咸新区沣西发展集团有限公司",
				path: "http://xxfxjt.com/template/images/common.files/logo.png",
				desc:
					"陕西省西咸新区沣西新城开发建设（集团）有限公司成立于2011年10月，注册资金20亿元，是由陕西省西咸新区沣西新城管委会和陕西西咸新区发展集团有限公司共同投资成立的国有企业。",
			},
			{
				name: "西安航天利科外包产业园开发建设有限公司",
				path: "",
				desc:
					"西安航天利科服务外包产业园开发建设有限公司成立于2010年10月9日，经营范围包括一般项目：物业管理；非居住房地产租赁；园区管理服务",
			},
			{
				name: "陕西建工沣西建设有限公司",
				path: "",
				desc:
					"陕西建工沣西建设有限公司成立于1995年11月24日，注册地位于陕西省西咸新区沣西新城总部经济园5号楼6层，法定代表人为任国彦。经营范围包括建筑工程、公路工程、桥梁工程、环保工程、水利工程、市政工程、园林绿化、装饰装修工程、机电安装工程、钻井工程的施工；基础设施建设；装配式建筑生产、制作及安装。（依法批准的项目，经相关部门批准后方可开展经营活动）（依法须经批准的项目，经相关部门批准后方可开展经营活动）陕西建工沣西建设有限公司对外投资1家公司，具有1处分支机构。",
			},
			{
				name: "西安怡阳房地产开发有限责任公司",
				path: "",
				desc:
					"西安怡阳房地产开发有限责任公司成立于2007年04月24日，注册地位于西安市高陵区鹿苑大道5号公馆，经营范围包括一般经营项目：房地产开发,销售；房屋租赁；物业管理；建筑材料销售；建筑装饰、装修工程施工；园林绿化工程施工；工程准备；水电安装。",
			},
			{
				name: "西安荣民科创房地产开发有限公司",
				path: "",
				desc: "经营范围包括一般项目：物业管理；房地产咨询；酒店管理。",
			},
			{
				name: "陕西合巨源房地产开发有限公司",
				path: "",
				desc:
					"陕西合巨源房地产开发有限公司于2013年03月15日成立。法定代表人周岗，公司经营范围包括：房地产项目开发；房地产的营销、策划、代理、销售；物业管理；房地产招商业务代理；企业项目的投资、房地产投资管理（限自有资金投资）；投资管理咨询（金融、证券、期货、基金投资咨询等许可项目除外）；旅游景区建设开发、施工、经营；旅游产品开发、销售等。",
			},
			{
				name: "甘肃建投建设有限公司",
				path: "http://www.gsjtw.cc/img/Nlogo.0747b365.png",
				desc:
					"甘肃省建设投资（控股）集团有限公司（简称“甘肃建投”），是全省首批国有资本投资公司试点单位之一，肩负服务全省发展战略、优化国有资本布局、提升产业竞争力的职责。连续11年位列中国企业500强，名列第291位，2022年完成经济总量1194.42亿元。",
			},
			{
				name: "中建新疆建工（集团）有限公司",
				path: "",
				desc:
					"中建新疆建工(集团)有限公司是世界 500 强第13位企业、全球最大建筑投资建设集团、国务院国资委直管上市大型央企——中国建筑股份有限公司的控股子公司。",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 4,
				num: 4,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 4,
				num: 4,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
	listData: {
		productList: [
			{ name: "6524内平开窗", img: dwcp1 },
			{ name: "7029内平开窗", img: dwcp2 },
			{ name: "7029内平开窗", img: dwcp3 },
			{ name: "7535内平开窗", img: dwcp4 },
			{ name: "8039内平开窗", img: dwcp5 },
			{ name: "9554近零能耗内平开窗", img: dwcp6 },
			{ name: "6524内平开门", img: dwcp7 },
			{ name: "7029内平开门", img: dwcp8 },
			{ name: "8039内平开门", img: dwcp9 },
			{ name: "6524外平开窗", img: dwcp10 },
			{ name: "7029外平开窗", img: dwcp11 },
			{ name: "8039外平开窗", img: dwcp12 },
			{ name: "6524外平开门", img: dwcp13 },
			{ name: "7029外平开门", img: dwcp14 },
			{ name: "8039外平开门", img: dwcp15 },
			{ name: "10664被动窗", img: dwcp16 },
			{ name: "10664A被动窗", img: dwcp17 },
			{ name: "10664A被动窗", img: dwcp18 },
			{ name: "11824断桥推拉窗", img: dwcp19 },
			{ name: "11824断桥双轨推拉门", img: dwcp20 },
			{ name: "15034断桥提升推拉门", img: dwcp21 },
			{ name: "185建筑级别阳光房", img: dwcp22 },
		],
		aim: "test",
		navList: [
			{
				name: "内平开窗",
				isShow: false,
				id: 1,
				children: [
					"6524内平开窗",
					"7029内平开窗",
					"7029内平开窗",
					"7535内平开窗",
					"8039内平开窗",
					"9554近零能耗内平开窗",
				],
			},
			{
				name: "内平开门",
				isShow: false,
				id: 2,
				children: ["6524内平开门", "7029内平开门", "8039内平开门"],
			},
			{
				name: "外平开窗",
				isShow: false,
				id: 3,
				children: ["6524外平开窗", "7029外平开窗", "8039外平开窗"],
			},
			{
				name: "外平开门",
				isShow: false,
				id: 4,
				children: ["6524外平开门", "7029外平开门", "8039外平开门"],
			},
			{
				name: "被动窗",
				isShow: false,
				id: 5,
				children: ["10664被动窗", "10664A被动窗", "10664A被动窗"],
			},
			{
				name: "推拉窗",
				isShow: false,
				id: 6,
				children: ["11824断桥推拉窗"],
			},
			{
				name: "推拉门",
				isShow: false,
				id: 7,
				children: ["11824断桥双轨推拉门", "15034断桥提升推拉门"],
			},
			{
				name: "阳光房",
				isShow: false,
				id: 8,
				children: ["185建筑级别阳光房"],
			},
		],
	},
	productDetailsData: {
		"6524内平开窗": {
			name: "6524内平开窗",
			img: dwcp1,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp1,
				},
			],
			price: "650",
			detailImgs: [dwcp1],
			modelNumberText: "SUPAI-W6524",
			brand: "素派系统门窗",
			describe:
				"6524内平开窗型材壁厚：1.8mm玻璃配置：双玻5mm+12A+5mm隔热条：24mm宽C/CT/CG 隔音性：35分贝 保温性：2.0-2.2W/M2·K水密性：500≤△P＜700气密性：1.0＜q1≤1.5抗风压性：4.0≤P3＜4.5",
			report: [dwbg1],
		},

		"7029内平开窗": {
			name: "7029内平开窗",
			img: dwcp2,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp2,
				},
			],
			price: "700",
			detailImgs: [dwcp2],
			modelNumberText: "SUPAI-W7029",
			brand: "素派系统门窗",
			describe:
				"7029内平开窗型材壁厚：1.8mm玻璃配置：双玻5mm+12A+5mm 隔热条：29mm宽C/CT/CG隔音性：35分贝保温性：1.8-2.0W/M2·K水密性：500≤△P＜700气密性：1.0＜q1≤1.5抗风压性：4.0≤P3＜4.5",
			// report: [],
		},
		"7029内平开窗": {
			name: "7029内平开窗",
			img: dwcp3,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp3,
				},
			],
			price: "750",
			detailImgs: [dwcp3],
			modelNumberText: "SUPAI-W7029",
			brand: "素派系统门窗",
			describe:
				"7029内平开窗型材壁厚：1.8mm玻璃配置：三玻5mm+12A+5mm+12A+5mm隔热条：29mm宽C/CT/CG隔音性：40分贝保温性：1.6-1.8W/M2·K水密性：500≤△P＜700气密性：1.0＜q1≤1.5抗风压性：4.0≤P3＜4.5",
			// report: [],
		},
		"7535内平开窗": {
			name: "7535内平开窗",
			img: dwcp4,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp4,
				},
			],
			price: "800",
			detailImgs: [dwcp4],
			modelNumberText: "SUPAI-W7535",
			brand: "素派系统门窗",
			describe: `7535外平开窗
                型材壁厚：1.8mm
                玻璃配置：三玻5mm+12A+5mm+12A+5mm
                隔热条：35mm宽C/CG/多腔体型
                隔音性：40分贝
                保温性：1.4-1.6W/M2·K
                水密性：500≤△P＜700
                气密性：0.5＜q1≤1.0
                抗风压性：4.5≤P3＜5.0`,
		},
		"8039内平开窗": {
			name: "8039内平开窗",
			img: dwcp5,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp5,
				},
			],
			price: "850",
			detailImgs: [dwcp5],
			modelNumberText: "SUPAI-W8039",
			brand: "素派系统门窗",
			describe: `8039内平开窗
            型材壁厚：1.8mm
            玻璃配置：三玻5mm+15A+5mm+15A+5mm
            隔热条：39mm宽CT/CG/多腔体型
            隔音性：40分贝
            保温性：1.2-1.4W/M2·K
            水密性：500≤△P＜700
            气密性：0.5＜q1≤1.0
            抗风压性：4.5≤P3＜5.0`,
			report: [dwbg2],
		},

		"9554近零能耗内平开窗": {
			name: "9554近零能耗内平开窗",
			img: dwcp5,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp6,
				},
			],
			price: "1500",
			detailImgs: [dwcp6],
			modelNumberText: "SUPAI-W9554",
			brand: "素派系统门窗",
			describe: `9554近零能耗内平开窗
            型材壁厚：1.8mm
            玻璃配置：三玻5mm+12A+5mm+14A+6mm
            隔热条：54mm宽C/CG/多腔体
            隔音性：40分贝
            保温性：1.0-1.2W/M2·K
            水密性：700≤△P
            气密性：q1≤0.5
            抗风压性：5.0≤P3`,
		},

		"6524内平开门": {
			name: "6524内平开门",
			img: dwcp7,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp7,
				},
			],
			price: "650",
			detailImgs: [dwcp7],
			modelNumberText: "SUPAI-W9554",
			brand: "素派系统门窗",
			describe: `6524内平开门
            型材壁厚：2.2mm
            玻璃配置：双玻5mm+18A+5mm
            隔热条：24mm宽C
            隔音性：35分贝
            保温性：2.0-2.2W/M2·K
            水密性：350≤△P＜500
            气密性：1.5＜q1≤2.0
            抗风压性：4.0≤P3＜4.5`,
		},

		"7029内平开门": {
			name: "7029内平开门",
			img: dwcp8,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp8,
				},
			],
			price: "750",
			detailImgs: [dwcp8],
			modelNumberText: "SUPAI-D7029",
			brand: "素派系统门窗",
			describe: `7029内平开门
            型材壁厚：2.2mm
            玻璃配置：三玻5mm+12A+5mm+12A+5mm
            隔热条：29mm宽CT
            隔音性：40分贝
            保温性：1.6-1.8W/M2·K
            水密性：350≤△P＜500
            气密性：1.5＜q1≤2.0
            抗风压性：4.0≤P3＜4.5`,
		},

		"8039内平开门": {
			name: "8039内平开门",
			img: dwcp9,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp9,
				},
			],
			price: "850",
			detailImgs: [dwcp9],
			modelNumberText: "SUPAI-D8039",
			brand: "素派系统门窗",
			describe: `8039内平开门
            型材壁厚：2.2mm
            玻璃配置：三玻5mm+15A+5mm+15A+5mm
            隔热条：39mm宽CT
            隔音性：40分贝
            保温性：1.2-1.4W/M2·K
            水密性：350≤△P＜500
            气密性：1.0＜q1≤1.5
            抗风压性：4.5≤P3＜5.0`,
		},

		"6524外平开窗": {
			name: "6524外平开窗",
			img: dwcp10,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp10,
				},
			],
			price: "700",
			detailImgs: [dwcp10],
			modelNumberText: "SUPAI-W6524",
			brand: "素派系统门窗",
			describe: `6524外平开窗
            型材壁厚：1.8mm
            玻璃配置：三玻5mm+12A+5mm+12A+5mm
            隔热条：24mm宽C/CT/CG
            隔音性：40分贝
            保温性：1.8-2.0W/M2·K
            水密性：500≤△P＜700
            气密性：1.0＜q1≤1.5
            抗风压性：4.0≤P3＜4.5`,
			report: [dwbg3],
		},

		"7029外平开窗": {
			name: "7029外平开窗",
			img: dwcp11,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp11,
				},
			],
			price: "750",
			detailImgs: [dwcp11],
			modelNumberText: "SUPAI-W7029",
			brand: "素派系统门窗",
			describe: `7029外平开窗
            型材壁厚：1.8mm
            玻璃配置：三玻5mm+12A+5mm+12A+5mm
            隔热条：29mm宽C/CT/CG
            隔音性：40分贝
            保温性：1.6-1.8W/M2·K
            水密性：500≤△P＜700
            气密性：1.0＜q1≤1.5
            抗风压性：4.0≤P3＜4.5`,
		},

		"8039外平开窗": {
			name: "8039外平开窗",
			img: dwcp12,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp12,
				},
			],
			price: "850",
			detailImgs: [dwcp12],
			modelNumberText: "SUPAI-W8039",
			brand: "素派系统门窗",
			describe: `8039外平开窗
            型材壁厚：1.8mm
            玻璃配置：三玻5mm+15A+5mm+15A+5mm
            隔热条：39mm宽CT/CG/多腔体型
            隔音性：40分贝
            保温性：1.2-1.4W/M2·K
            水密性：500≤△P＜700
            气密性：0.5＜q1≤1.0
            抗风压性：4.5≤P3＜5.0`,
		},

		"6524外平开门": {
			name: "6524外平开门",
			img: dwcp13,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp13,
				},
			],
			price: "650",
			detailImgs: [dwcp13],
			modelNumberText: "SUPAI-D6524",
			brand: "素派系统门窗",
			describe: `6524外平开门
            型材壁厚：2.2mm
            玻璃配置：双玻5mm+18A+5mm
            隔热条：24mm宽C
            隔音性：35分贝
            保温性：2.0-2.2W/M2·K
            水密性：350≤△P＜500
            气密性：1.5＜q1≤2.0
            抗风压性：4.0≤P3＜4.5`,
		},

		"7029外平开门": {
			name: "7029外平开门",
			img: dwcp14,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp14,
				},
			],
			price: "750",
			detailImgs: [dwcp14],
			modelNumberText: "SUPAI-D7029",
			brand: "素派系统门窗",
			describe: `7029外平开门
            型材壁厚：2.2mm
            玻璃配置：三玻5mm+12A+5mm+12A+5mm
            隔热条：29mm宽CT
            隔音性：40分贝
            保温性：1.6-1.8W/M2·K
            水密性：350≤△P＜500
            气密性：1.5＜q1≤2.0
            抗风压性：4.0≤P3＜4.5`,
		},

		"8039外平开门": {
			name: "8039外平开门",
			img: dwcp15,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp15,
				},
			],
			price: "850",
			detailImgs: [dwcp15],
			modelNumberText: "SUPAI-D8039",
			brand: "素派系统门窗",
			describe: `8039外平开门
            型材壁厚：2.2mm
            玻璃配置：三玻5mm+15A+5mm+15A+5mm
            隔热条：39mm宽CT
            隔音性：40分贝
            保温性：1.2-1.4W/M2·K
            水密性：350≤△P＜500
            气密性：1.0＜q1≤1.5
            抗风压性：4.5≤P3＜5.0`,
		},

		"10664被动窗": {
			name: "10664被动窗",
			img: dwcp16,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp16,
				},
			],
			price: "1800",
			detailImgs: [dwcp16],
			modelNumberText: "SUPAI-W10664",
			brand: "素派系统门窗",
			describe: `10664被动窗
            型材壁厚：1.8mm
            玻璃配置：三玻5mm+18A+5mm+18A+6mm
            隔热条：64mm宽C/CG/多腔体
            隔音性：40分贝
            保温性：0.8W/M2·K
            水密性：700≤△P
            气密性：q1≤0.5
            抗风压性：5.0≤P3`,
		},

		"10664A被动窗": {
			name: "10664A被动窗",
			img: dwcp17,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp17,
				},
			],
			price: "2000",
			detailImgs: [dwcp17],
			modelNumberText: "SUPAI-W10664",
			brand: "素派系统门窗",
			describe: `10664A被动窗
            型材壁厚：1.8mm
            玻璃配置：四玻5mm+14A+5mm+14A+6mm+0.76PVB+6mm
            隔热条：64mm宽C/CG/多腔体
            隔音性：45分贝
            保温性：0.8W/M2·K
            水密性：700≤△P
            气密性：q1≤0.5
            抗风压性：5.0≤P3`,
		},

		"10664A被动窗": {
			name: "10664A被动窗",
			img: dwcp18,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp18,
				},
			],
			price: "1900",
			detailImgs: [dwcp18],
			modelNumberText: "SUPAI-W10664",
			brand: "素派系统门窗",
			describe: `10664A被动窗
            型材壁厚：1.8mm
            玻璃配置：四玻5mm+14A+5mm+14A+5mm+14A+5mm
            隔热条：64mm宽C/CG/多腔体
            隔音性：45分贝
            保温性：0.8W/M2·K
            水密性：700≤△P
            气密性：q1≤0.5
            抗风压性：5.0≤P3`,
		},

		"11824断桥推拉窗": {
			name: "11824断桥推拉窗",
			img: dwcp19,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp19,
				},
			],
			price: "750",
			detailImgs: [dwcp19],
			modelNumberText: "SUPAI-W11824",
			brand: "素派系统门窗",
			describe: `11824断桥推拉窗
            型材壁厚：1.8mm
            玻璃配置：双玻6mm+15A+6mm
            隔热条：24mm宽C
            隔音性：35分贝
            保温性：:2.0-2.2W/M2·K
            水密性：350≤△P＜500
            气密性：1.5＜q1≤2.0
            抗风压性：4.0≤P3＜4.5`,
			report: [dwbg4],
		},

		"11824断桥双轨推拉门": {
			name: "11824断桥双轨推拉门",
			img: dwcp20,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp20,
				},
			],
			price: "750",
			detailImgs: [dwcp20],
			modelNumberText: "SUPAI-D11824",
			brand: "素派系统门窗",
			describe: `11824断桥双轨推拉门
            型材壁厚：2.2m
            玻璃配置：双玻6mm+15A+6mm
            隔热条：24mm宽C
            隔音性：35分贝
            保温性：:2.0-2.2W/M2·K
            水密性：350≤△P＜500
            气密性：1.5＜q1≤2.0
            抗风压性：4.0≤P3＜4.5`,
		},

		"15034断桥提升推拉门": {
			name: "15034断桥提升推拉门",
			img: dwcp21,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp21,
				},
			],
			price: "1500",
			detailImgs: [dwcp21],
			modelNumberText: "SUPAI-D15034",
			brand: "素派系统门窗",
			describe: `15034断桥提升推拉门
            型材壁厚：2.2m
            玻璃配置：三玻6mm+12A+6mm+12A+6mm
            隔热条：34mm宽C/CT
            隔音性：40分贝
            保温性：:1.4-1.6W/M2·K
            水密性：700≤△P
            气密性：0.5＜q1≤1.0
            抗风压性：4.5≤P3＜5.0`,
		},

		"185建筑级别阳光房": {
			name: "185建筑级别阳光房",
			img: dwcp22,
			modelNumber: [
				{
					title: "暂无",
					img: dwcp22,
				},
			],
			price: "2000",
			detailImgs: [dwcp22],
			modelNumberText: "SUPAI-R185",
			brand: "素派系统门窗",
			describe: `185建筑级别阳光房
            全铝型衫材：125系列155系列主梁单侧壁厚4.8mm，185系列主梁单侧壁厚6.0mm，承重力更强。
            
            防水设计：所有连接处均采用折弯铝板与玻璃压板叠加压合方式，杜绝雨水渗透。
            
            保温隔热：型材采用断桥设计，L0W-E玻璃搭配汽车级三元乙丙胶条，优异气密水密性能，冷暖热量不流失，保暖隔热。
            
            安全设计：前大梁与主梁连接均采用专属钢件连接，后梁与主梁采用托盘式连接，使其具备建筑级的承重能力和具有一定的抗震性能。
            
            表面涂装：氟碳静电粉末喷涂，耐暴晒耐腐蚀，抗油污方便打理。`,
		},

		//产品详情右侧推荐
		detailRightImgs: [],
	},
	contactListData: {
		list: [
			{
				name: "客服",
				position: "",
				id: "3",
				phoneNum: "--",
				telephone: "400-700-9860",
				color: "#219b94",
				email: "",
			},
			{
				name: "李开梅",
				position: "助理",
				id: "2",
				phoneNum: "13572926357",
				telephone: "--",
				color: "#007DFF ",
				email: "",
			},
		],
	},
	caseData: {
		list: [
			{
				name: "理想欣港湾小区",
				id: 1,
				price: "3034万元",
				time: "2022",
				site: "陕西西咸新区沣西新城",
				type: "住宅",
				unit: "陕西西咸新区沣西发展集团有限公司",
				desc:
					"理想欣港湾小区工程位于沣西新城天元路以北，兴信路以西，翱翔四路以南，鲲鹏路以东。总建筑面积为182878.16㎡，其中地上建筑面积为111923.01㎡，地下建筑面积为77955.15㎡，场内建11栋高层。地下室部分地下2层，部分地下1层，负二层层高4.0m，负一层层高4.4m。框架剪力墙结构，总建筑面积70955.15㎡基础采用筏板+下柱墩，天然地基。±0.000相当于绝对标高390.200m（黄海高程）。设计使用年限50年，建筑抗震设防类别丙类，建筑结构安全等级二级，抗震设防烈度8度，地基基础设计等级乙级，结构耐火等级为一级。",
				//轮播图
				proImgList: [{ title: "", path: dwf1 }],
				//现场图片
				imgList: [],
				//合作证明
				contractList: [
					{ title: "", path: dwhz1 },
					{ title: "", path: dwhz2 },
				],
				product: "铝合金系统窗",
			},
			{
				name: "云和悦小区项目",
				id: 2,
				price: "1657万元",
				time: "2023",
				site: "陕西省泾河新城",
				type: "住宅",
				unit: "西咸新区泾河新城云宸城市发展有限公司",
				desc:
					"云和悦小区施工总承包工程项目位于陕西省泾河新城泾河大道北侧，泾河三街与湖滨四路十字东南角，总占地面积4.1万㎡。项目共计9栋楼，其中6栋17层，3栋6层，东侧与北侧为售楼部、开敞空间及其他配套设施，项目总建筑面积约13万㎡，造价约6.3亿元，项目周围均为预建规划路。.16㎡，其中地上建筑面积为111923.01㎡，地下建筑面积为77955.15㎡，场内建11栋高层。地下室部分地下2层，部分地下1层，负二层层高4.0m，负一层层高4.4m。框架剪力墙结构，总建筑面积70955.15㎡基础采用筏板+下柱墩，天然地基。±0.000相当于绝对标高390.200m（黄海高程）。设计使用年限50年，建筑抗震设防类别丙类，建筑结构安全等级二级，抗震设防烈度8度，地基基础设计等级乙级，结构耐火等级为一级。",
				//轮播图
				proImgList: [{ title: "", path: dwf2 }],
				//现场图片
				imgList: [],
				//合作证明
				contractList: [
					{ title: "", path: dwhz3 },
					{ title: "", path: dwhz4 },
				],
				product: "铝合金系统窗",
			},
			{
				name: "西安航天利科服务外包产业园项目5、6号楼",
				id: 3,
				price: "219万元",
				time: "2021",
				site: "陕西省西安市长安区",
				type: "住宅",
				unit: "西安航天利科服务外包产业园开发建设有限公司",
				desc: "西安航天利科服务外包产业园项目共计11栋楼；建筑面积81435.95m2。",
				//轮播图
				proImgList: [{ title: "", path: dwf3 }],
				//现场图片
				imgList: [],
				//合作证明
				contractList: [
					{ title: "", path: dwhz5 },
					{ title: "", path: dwhz6 },
				],
				product: "铝合金系统窗",
			},
			{
				name: "中国丝路科创谷起步区05单元E地块",
				id: 4,
				price: "645万元",
				time: "2022",
				site: "沣西新城",
				type: "住宅",
				unit: "西咸新区丝路科元建设有限公司",
				desc:
					"中国丝路科创谷起步区05单元E地块位于沣西新城规划科创谷一路南侧，科技北以北，科创谷三路以东，科创谷五路以西，场地地形平坦，地面标高介390.42-391.19m之间，最大高差约为0.77m，地面平均标高390.93m，地貌单元属渭河右岸一级阶地。05单元E地块拟建建筑物3-15层，框架或框架剪力墙结构。.95m2。",
				//轮播图
				proImgList: [{ title: "", path: dwf4 }],
				//现场图片
				imgList: [],
				//合作证明
				contractList: [
					{ title: "", path: dwhz7 },
					{ title: "", path: dwhz8 },
				],
				product: "铝合金系统窗",
			},
			{
				name: "泰林·黄河馨苑住宅小区二期工程",
				id: 5,
				price: "1295万元",
				time: "2022",
				site: "兰州高新区雁滩园区",
				type: "住宅",
				unit: "兰州泰林房地产开发有限责任公司",
				desc:
					"本工程为兰州泰林·黄河馨苑住宅小区二期工程项目，建设用地位于兰州高新区雁滩园区 S631 -2#规划路以北，B632#规划路以西，泰林·黄河馨苑项目一期用地以南，省人口委用地以东范围。共拟建4栋地上建筑，其中10#~12#均一类高层住宅与单层商业组合的组合建筑。10-1#地上33层，10-2#地上10层，其中2-33层系统窗面积3202.22平方米；11#地上30层，其中2-30层系统窗面积3115.23平方米；12-1#地上10层，12-2#地上32层，其中2-32层系统窗面积3191.20平方米，总计系统窗面积9508.66平方米。",
				//轮播图
				proImgList: [{ title: "", path: dwf5 }],
				//现场图片
				imgList: [],
				//合作证明
				contractList: [
					{ title: "", path: dwhz9 },
					{ title: "", path: dwhz10 },
				],
				product: "铝合金系统窗",
			},
			{
				name: "沣西·逸园三期项目",
				id: 6,
				price: "--",
				time: "--",
				site: "陕西省西咸新区",
				type: "住宅",
				unit: "陕西省沣西置业有限公司",
				desc:
					"沣西·逸园三期项目工程位于沣西新城沣渭大道以东，天雄西路以北，天府路以南，绿廊一期以西。总建筑面积为16239㎡，其中地上建筑面积为15112㎡，地下建筑面积为1127㎡，场内建8栋多层。 地上7层，地下1层。框架剪力墙结构，总建筑面积70955.15㎡基础采用筏板+下柱墩，天然地基。±0.000相当于绝对标高392.40m（黄海高程）。设计使用年限50年，抗震设防烈度8度，外窗气密性6级，外窗保温性8级。",
				//轮播图
				proImgList: [{ title: "", path: dwf6 }],
				//现场图片
				imgList: [],
				//合作证明
				contractList: [],
				product: "铝合金系统窗",
			},
		],
	},
	evaluationData: {
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${2}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${2}.png`,
				title: "绿色认证",
				isShow: true,
			},
		],
	},

	successfulBidderData: {
		info: [
			{
				name1: "云和悦小区门窗制作及安装",
				name2: "云和悦小区门窗制作及安装",
				name3: "物资采购",
				date: "2023/1/10",
			},
			{
				name1: "理想欣港湾小区住宅系统窗采购与安装",
				name2: "理想欣港湾小区住宅系统窗采购与安装",
				name3: "物资采购",
				date: "2022/3/28",
			},
			{
				name1: "玻璃栏杆专业分包任务",
				name2: "玻璃栏杆专业分包任务",
				name3: "物资采购",
				date: "2019/3/25",
			},
		],
	},
	lawData: {
		info: [],
	},
	tipData: {
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立5年以上",
			},
		],
	},
};
